
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manage/list-token",
      function () {
        return require("private-next-pages/manage/list-token.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manage/list-token"])
      });
    }
  